<div class="tips-header">
  <div class="taak">
    @if (taak) {
      <div class="mat-subtitle-1">{{taak.getLabel()}}</div>
    }
    @if (categorie) {
      <div>{{categorie.getLabel()}}</div>
    }
  </div>
  <div>
    @if (client) {
      <span class="mat-subtitle-1">{{client.getNaam()}}</span>
    }
    @if (client) {
      <span> ({{client.getNummer()}})</span>
    }
  </div>
</div>
